<template>
    <div>
        <div v-if="loading" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.8); z-index: 9999;">
            <p style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 20px; color: #ddd;">导出中，请勿关闭页面...</p>
        </div>
        <div class="detail-box" id="pdfDom">
            <el-row class="zy-list">
                <div>
                    <h2>
                        {{planObj.plan_title}}
                        <span>
                            <div class="plan-percent">{{ planObj.avg_percent ? planObj.avg_percent:'-' }}%</div>
                            <div>录取总概率</div>
                        </span>
                    </h2>
                    <p>{{planObj.create_time|dateHandler}}</p>
                    <div v-for="(item,index) in batchKeyList" :key="index" class="el-collapse">
                        <div  v-if="planObj.plan_info[item]">
                            <div name="1" class="collapse-title el-collapse-item" v-if="planObj.plan_info[item].is_plan">
                                <div>
                                    <el-row class="el-collapse-item__header">
                                        {{planObj.subject}}<span></span>{{planObj.score}}<span></span>{{planObj.plan_info[item].local_batch_type}}
                                    </el-row>
                                </div>
                                <div class="el-collapse-item__wrap">
                                    <template v-for="(plan,index_plan) in planObj.plan_info[item].arr_tmp" >
                                        <div :class="index_plan == 0 && plan_key == item ? 'gk-height': index_plan == 0 && plan_key != item ? 'gk-height2':'gk-height1'" class="el-collapse">
                                            <template v-for="(item1,index1) in plan">
                                                <div v-if="item1.plan_scl.scl_id" class="el-collapse-item">
                                                    <div>
                                                        <el-row class="collapse-box el-collapse-item__header">
                                                            <el-col :span="2">
                                                                <div class="zy-type">{{item1.plan_type}}</div>
                                                            </el-col>
                                                            <el-col :span="2">
                                                                <el-image src="'../../assets/images/scl_default.png" alt="大学logo">
                                                                    <div slot="error" class="image-slot">
                                                                        <img src="../../assets/images/scl_default.png" alt="大学logo">
                                                                    </div>
                                                                </el-image>
                                                            </el-col>
                                                            <el-col :span="17">
                                                                <div class="zytb-school-name">
                                                                    {{item1.plan_scl.scl_name}}
                                                                    {{item1.plan_scl.plan_group? item1.plan_scl.plan_group : ''}}
                                                                    <span style="margin: 0" v-if="item1.plan_scl.year >= 2024">{{item1.plan_scl.first_choose }}</span>
                                                                    <span style="margin: 0" v-else>首选{{ item1.plan_scl.first_choose ? subject[item1.plan_scl.first_choose]:'不限'}},
                                                                        <template v-if="item1.plan_scl.second_choose">再选<template v-for="sub in item1.plan_scl.second_choose.split('&')">{{subject[sub]}}</template>
                                                                        </template>
                                                                        <template v-else>
                                                                            再选不限
                                                                        </template>
                                                                    </span>
                                                                </div>
                                                                <div class="zytb-school-tag">
                                                                    <span v-if="item1.plan_scl.name">{{item1.plan_scl.name}}</span>
                                                                    <span v-if="item1.plan_scl.school_nature_type">{{item1.plan_scl.school_nature_type}}</span>
                                                                    <span v-if="item1.plan_scl.school_type">{{item1.plan_scl.school_type}}</span>
                                                                    <span v-if="item1.plan_scl.school_nature">{{item1.plan_scl.school_nature}}</span>
                                                                    <span v-if="item1.plan_scl.f211 == '1'" style="background:#fff4e3;color:#fe9f0a;">211</span>
                                                                    <span v-if="item1.plan_scl.f985 == '1'" style="background:#fff0e9;color:$common-color;">985</span>
                                                                    <span v-if="item1.plan_scl.dual_class != '38003' && item1.dual_class" style="background:#e4f4e9;color:#01c13b;">双一流</span>
                                                                    <span v-if="item1.plan_scl.is_provincial == '1'" style="background: #FDEFFF;color: #D250E0">省重点</span>
                                                                    <span v-if="item1.plan_scl.is_doublehigh == '77'" style="background: #ECEDFF;color: #5964FF">双高计划</span>
                                                                </div>
                                                                <div class="zytb-school-count">
                                                                    <div style="line-height: 20px;">
                                                                        <span>{{Number(item1.plan_scl.year) + 1}}招生计划{{item1.plan_scl.scl_plan_num?item1.plan_scl.scl_plan_num:'--'}}人</span>
                                                                        <span>最低学费{{item1.plan_scl.min_tuition ? item1.plan_scl.min_tuition : '--'}}</span>
                                                                        <span>{{item1.plan_scl.college_code ? '学校代码' + item1.plan_scl.college_code : '' }}</span>
                                                                    </div>
                                                                    <div style="line-height: 20px;">
                                                                        <span>{{item1.plan_scl.year}}年最低分{{item1.plan_scl.score_min?item1.plan_scl.score_min:'--'}}</span>
                                                                        <span>最低位次{{item1.plan_scl.min_section?item1.plan_scl.min_section:'--'}}</span>
                                                                        <span v-if="planObj.section_line && item1.plan_scl.min_section">比我的位次{{planObj.section_line - item1.plan_scl.min_section >= 0 ? '高' : '低'}}{{Math.abs(planObj.section_line - item1.plan_scl.min_section)}}</span>
                                                                        <span v-else>比我的位次-</span>
                                                                    </div>
                                                                    <div style="line-height: 20px;margin-bottom: 10px;">
                                                                        <span>{{Number(item1.plan_scl.year) - 1}}招生计划{{item1.plan_scl.sp_num2?item1.plan_scl.sp_num2:'--'}}人</span>
                                                                        <span>{{Number(item1.plan_scl.year) - 1}}年最低分{{item1.plan_scl.sp_min2?item1.plan_scl.sp_min2:'--'}}</span>
                                                                        <span>最低位次{{item1.plan_scl.sp_min_section2?item1.plan_scl.sp_min_section2:'--'}}</span>
                                                                        <span v-if="planObj.section_line && item1.plan_scl.sp_min_section2">比我的位次{{planObj.section_line - item1.plan_scl.sp_min_section2 >= 0 ? '高' : '低'}}{{Math.abs(planObj.section_line - item1.plan_scl.sp_min_section2)}}</span>
                                                                        <span v-else>比我的位次--</span>
                                                                    </div>
                                                                </div>
                                                            </el-col>
                                                            <el-col :span="3">
                                                                <div class="zytb-school-major">已选专业({{item1.specialty_data.length}})个</div>
                                                                <div class="con-clear"></div>
                                                            </el-col>
                                                        </el-row>
                                                    </div>
                                                    <div class="el-collapse-item__wrap el-collapse-item__content">
                                                        <el-row class="collapse-box collapse-box-diff" v-for="(item2,index2) in item1.specialty_data" :key="index2">
                                                            <el-col :span="21" >
                                                                <el-row class="zytb-school-name">
                                                                    <el-col :span="20">
                                                                        <div>
                                                                            {{item2.spname}}
                                                                        </div>
                                                                        <div class="zytb-school-count">
                                                                            <div style="line-height: 20px;">
                                                                        <span>{{Number(item2.year) + 1}}招生计划{{item2.plan_num?item2.plan_num:'--'}}人</span>
                                                                        <span>学费{{item2.tuition ? item2.tuition : '--'}}</span>
                                                                        <span>{{item2.plan_code ? '专业代码' + item2.plan_code : '' }}</span>
                                                                    </div>
                                                                    <div style="line-height: 20px;">
                                                                        <span>{{item2.year}}招生计划{{item2.sp_num?item2.sp_num:'--'}}人</span>
                                                                        <span>{{item2.year}}年最低分{{item2.sp_min?item2.sp_min:'--'}}</span>
                                                                        <span>最低位次{{item2.sp_min_section?item2.sp_min_section:'--'}}</span>
                                                                        <span v-if="planObj.section_line && item2.sp_min_section">比我的位次{{planObj.section_line - item2.sp_min_section >= 0 ? '高' : '低'}}{{Math.abs(planObj.section_line - item2.sp_min_section)}}</span>
                                                                        <span v-else>比我的位次--</span>
                                                                    </div>
                                                                    <div style="line-height: 20px;">
                                                                        <span>{{Number(item2.year) - 1}}招生计划{{item2.sp_num2?item2.sp_num2:'--'}}人</span>
                                                                        <span>{{Number(item2.year) - 1}}年最低分{{item2.sp_min2?item2.sp_min2:'-'}}</span>
                                                                        <span>最低位次{{item2.sp_min_section2?item2.sp_min_section2:'-'}}</span>
                                                                        <span v-if="planObj.section_line && item2.sp_min_section2">比我的位次{{planObj.section_line - item2.sp_min_section2 >= 0 ? '高' : '低'}}{{Math.abs(planObj.section_line - item2.sp_min_section2)}}</span>
                                                                        <span v-else>比我的位次--</span>
                                                                    </div>
                                                                        </div>
                                                                    </el-col>
                                                                    <el-col :span="4" v-if="item2.percent">
                                                                        <span>{{item2.percent}}%
                                                                            <div>录取概率</div>
                                                                        </span>
                                                                    </el-col>
                                                                </el-row>
                                                            </el-col>
                                                            <div class="con-clear"></div>
                                                        </el-row>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-row>
        </div>
    </div>
</template>

<script>
import { getMyPlanDetail, getSearchDic } from '@/api/zhiyuan'
export default {
    data() {
        return {
            id:'',
            title: '',
            planObj: {},
            plan_key: -99,
            savePlanInfor1: this.$store.state.user.savePlanInfor,
            planYearStr1: this.$store.state.user.planYearStr,
            batchKeyListDiff1: Object.keys(JSON.parse(sessionStorage.getItem('batchObj'))),
            batchKeyListDiff2: ["plan_4", "plan_1", "plan_2", "plan_3", "plan_5"],
            batchKeyList: [4, 1, 2, 3, 5],
            subject: {
                wl: '物理',
                hx: '化学',
                zz: '政治',
                sw: '生物',
                dl: '地理',
                ls: '历史'
            },
            type_edu: {},
            loading: true
        }
    },
    filters: {
        dateHandler(time) {
            return time.replace(/(\-)/g,'/');
        }
    },
    mounted() {
        this.title = this.$route.query.title;
        this.id = this.$route.query.id;
        this.getSearchDicHandler();
        setTimeout(()=>{
            this.getMyPlanDetailHandler();
        }, 200)
    },
    methods: {
        getSearchDicHandler() {
            try {
                getSearchDic().then(res => {
                    if (res.status != 200 || !res) {
                        return
                    }
                    res.data.edu_type.map( item => {
                        this.type_edu[item.dic_code] = item.dic_value
                    })
                }).catch(error => {
                    console.log(error);
                })
            } catch (error) { console.log(error) }
        },
        getMyPlanDetailHandler() {
            getMyPlanDetail(this.id).then(res => {
                const data = res.data;
                let planObj = {...res.data};
                let zyObj = data.plan_desc.split("/");
                planObj.subject = zyObj[0];
                planObj.score = zyObj[1];
                let plan_info = {...JSON.parse(data.plan_info)};
                for (const key in plan_info) {
                    if(key != 'avg_percent') {
                    const plan_data = plan_info[key].plan_data
                    if(plan_data[0].specialty_data.length > 0) {
                        if(this.plan_key === -99) {
                            this.plan_key = key
                        }
                    }
                    const arr_tmp = []
                    plan_data.map((item, index) => {
                        const plan_scl = item.plan_scl;
                        let school_type = '';
                        let school_nature = '';
                        let school_nature_type = '';
                        if(plan_scl.scl_type == '5000') {
                            school_type = '综合'
                        } else if(plan_scl.scl_type == '5001') {
                            school_type = '理工'
                        } else if(plan_scl.scl_type == '5002') {
                            school_type = '农林'
                        } else if(plan_scl.scl_type == '5003') {
                            school_type = '医药'
                        } else if(plan_scl.scl_type == '5004') {
                            school_type = '师范'
                        } else if(plan_scl.scl_type == '5005') {
                            school_type = '语言'
                        } else if(plan_scl.scl_type == '5006') {
                            school_type = '财经'
                        } else if(plan_scl.scl_type == '5007') {
                            school_type = '政法'
                        } else if(plan_scl.scl_type == '5008') {
                            school_type = '体育'
                        } else if(plan_scl.scl_type == '5009') {
                            school_type = '艺术'
                        } else if(plan_scl.scl_type == '5010') {
                            school_type = '民族'
                        } else if(plan_scl.scl_type == '5011') {
                            school_type = '军事'
                        }
                        else {
                            school_type = '其他'
                        }
                        if(plan_scl.scl_nature == '36000') {
                            school_nature = '公办'
                        } else if(plan_scl.scl_nature == '36001') {
                            school_nature = '民办'
                        } else if(plan_scl.scl_nature == '36002') {
                            school_nature = '中外合作办学'
                        }
                        // if(plan_scl.scl_nature_type == '6000') {
                        //     if(plan_scl.f211 == '1' || plan_scl.f985 == '1' || plan_scl.is_provincial == '1' || (plan_scl.dual_class != '38003' && plan_scl.dual_class)) {
                        //         school_nature_type = '本科'
                        //     } else {
                        //         school_nature_type = '普通本科'
                        //     }
                        // } else if(plan_scl.scl_nature_type == '6001') {
                        //     if(plan_scl.is_doublehigh == '77') {
                        //         school_nature_type = '专科'
                        //     } else {
                        //         school_nature_type = '普通专科'
                        //     }
                        // } else if(plan_scl.scl_nature_type == '6002') {
                        //     school_nature_type = '中外合作办学'
                        // }
                        plan_scl.school_type = school_type;
                        plan_scl.school_nature = school_nature;
                        plan_scl.school_nature_type = this.type_edu[plan_scl.scl_nature_type];
                        item.plan_scl = plan_scl;
                        // return item;
                    })
                    for(var i=0; i<plan_data.length; i++){
                        if(plan_data[i].specialty_data.length > 0) {
                            arr_tmp.push(plan_data.slice(i,i+1));
                        }
                    }
                    plan_info[key].arr_tmp = arr_tmp;
                    }
                }
                planObj.plan_info = {...plan_info};
                const key_tmp = Object.keys(planObj.plan_info)
                const index_tmp = key_tmp.map(val => { return val.indexOf('plan_') })
                const index_tmp1 = key_tmp.indexOf('1') || key_tmp.indexOf('2') || key_tmp.indexOf('3') || key_tmp.indexOf('4') || key_tmp.indexOf('5')
                if(index_tmp.indexOf(0) === -1) {
                    if(index_tmp1 === -1) {
                        this.batchKeyList = this.batchKeyListDiff1
                    }
                } else {
                    this.batchKeyList = this.batchKeyListDiff2
                }
                this.planObj = planObj;
                const self = this
                setTimeout(() => {
                  self.getPdf(self.planObj.plan_title)
                }, 1000)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    .detail-box {
        // @include gwidth;
        // background: #e2e2e2;
        background-color: rgb(245, 247, 250);
        width: 1000px;
        margin: 0 auto;
    }
    .zy-list {
        background: #ffffff;
        padding: 0 20px;
        box-sizing: border-box;
        h2 {
            font-size: 32px;
            font-weight: 500;
            color: #2c2e33;
            margin-top: 50px;
            > span {
                display: inline-block;
                width: 80px;
                height: 77px;
                background: #f5f7fa;
                border-radius: 4px;
                font-size: 12px;
                color: #999390;
                line-height: 17px;
                padding: 18px 10px;
                box-sizing: border-box;
                text-align: center;
                float: right;
                .plan-percent {
                    font-size: 20px;
                    color: $common_color;
                    line-height: 28px;
                }
            }
        }
        p {
            font-size: 16px;
            color: #909399;
            padding-bottom: 24px;
            border-bottom: 1px solid #f0f2f5;
        }
    }
    .collapse-box {
		width: 100%;
		font-size: 0;
		.el-image, img {
			width: 64px;
			height: 64px;
		}
        .zy-type {
            width: 54px;
            height: 30px;
            border: 1px solid $common-color;
            border-radius: 5px;
            font-size: 14px;
            color: $common-color;
            text-align: center;
            line-height: 30px;
            margin-top: -10px;
        }
        .el-col-2 {
			width: 7%;
		}
		.el-col-3 {
			width: 11%;
		}
        .el-col-4 {
            float: right;
        }
		.zytb-school-name {
			font-size: 18px;
			font-weight: 600;
			color: #2c2e33;
			margin-bottom: 5px;
		}
		.zytb-school-tag span {
			display: inline-block;
			padding: 3px 8px;
			font-size: 12px;
			color: #909399;
			height: 22px;
			background: #f0f2f5;
			border-radius: 4px;
			line-height: 22px;
			margin-right: 4px;
		}
		.zytb-school-count span {
			font-size: 12px;
			color: #909399;
			margin-right: 12px;
		}
		.zytb-school-major {
			color: $common-color;
			font-size: 14px;
			margin-top: -15px;
			position: relative;
			right: -40px;
            text-align: right;
		}
	}
	.collapse-box-diff {
        @include gflex;
        justify-content: flex-end;
        .zytb-school-name .el-col-4 {
            text-align: right;
            > span {
                display: inline-block;
                padding: 3px 8px;
                font-size: 16px;
                color: #ff6524;
                background: #f0f2f5;
                border-radius: 4px;
                line-height: 22px;
                margin-left: 4px;
                margin-top: 10px;
                text-align: center;
                span {
                    font-size: 12px;
                }

                div {
                    font-size: 12px;
                    color: #999390;
                    margin-top: -5px;
                }
            }
        }
        .el-col-21 {
            width: 86%;
        }
		button {
			width: 86px;
			height: 30px;
			line-height: 26px;
			border: 1px solid $common-color;
			border-radius: 5px;
			color: $common-color;
			text-align: center;
			background-color: #fff;
			font-size: 14px;
			float: right;
			margin-top: 10px;
			position: relative;
			img {
				width: 14px;
				height: 14px;
				top: -2px;
				left: 13px;
				position: absolute;
			}
		}
		.zytb-school-btn {
			background: $common-color;
			color: #fff;
			text-align: right;
			padding-right: 8px;
		}
	}
	// .collapse-box-diff:not(:last-child) {
	// 	margin-bottom: 16px;
	// }
    ::v-deep {
        .el-collapse-item__header {
            height: 180px;
        }
        .collapse-box-diff {
            margin-bottom: 0;
        }
    }
    .gk-height {
        height: 1200px;
    }
    .gk-height2 {
        height: 1340px;
        padding-top: 10px!important;
        box-sizing: border-box;
    }
    .gk-height1 {
        height: 1415px;
        padding-top: 10px!important;
        box-sizing: border-box;
    }
</style>